import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Global_ISDA_Functions } from 'Root/global/global';
import { fetchJurisdictionsDispatch } from '../actions/index';
import DocumentDownloadLink from '../../components/document-download-link';
//TODO import prop-types as dependency
//import PropTypes from 'prop-types';

class InformalUpdateRow extends Component {
	constructor( props ) {
		super( props );
		this.returnJurisdictionRow = this.returnJurisdictionRow.bind( this );
		this.state = {
			country: '', firms: [], flag: '', countryName: '', files: []
		};
	}

	//TODO can we use propTypes with our version of react
	//	static propTypes = {
	//		informalUpdates: PropTypes.string.isRequired,
	//      fetchJurisdictionsDispatch : PropTypes.func.isRequired
	//	}

	componentDidMount() {
		this.props.fetchJurisdictionsDispatch();
		let reactWrapper = document.querySelector( '.react-fallback' );
		this.addWrapperClass( reactWrapper );
	}

	addWrapperClass( wrapper ) {
		let globalIsdaFunctions = new Global_ISDA_Functions();
		globalIsdaFunctions.vanillaAddClass( wrapper, 'visible' );
		globalIsdaFunctions.vanillaAddClass( wrapper, 'loaded' );
	}

	returnJurisdictionRow() {
		if ( '' === this.state.country ) {
			return null;
		}

		let firms = this.state.firms.map( firm => {
			return <li className="contact-item">
				<p><strong>Firm Name</strong>: { firm.firm_name_new }</p>
				{ firm.contacts.map( contact => {
					let contactName = contact.name;
					let contactEmail = contact.email;
					return <p>
						<strong>Contact: </strong>{ contactName }: &nbsp;
						<a href={ 'mailto:' + contactEmail } className="informal-update-email"><span className="glyphicon glyphicon-envelope informal-update-glyphicon-envelope" aria-hidden="true"></span> Send Email</a>
					</p>;
				} ) }
			</li>;
		} );
 
		let filesToOutput = Object.keys( this.state.files ).map( filePath => {
			return <DocumentDownloadLink link={filePath} title={this.state.files[filePath]} />
		} );
		return (
			<div className="two-col-content-panel opinion-info informal-country-update-row">
				<div className="col-sm-8 tab-content">
					<div role="tabpanel" className="tab-pane fade in active">
						<h3 className="country-name">{ this.state.countryName }
							<span><img className="flag-status informal-country-update-flag" src={ this.state.flag } alt="" /></span>
						</h3>
					</div>
					<div>
						<ul className="contacts-list">
							{ firms }
						</ul>
					</div>
				</div>
				<div className="col-sm-4 informal-documents-wrapper">
					<h3 className="assets-list-title">Documents ({ Object.keys( this.state.files ).length })</h3>
					<ul className="assets-list">
						{ filesToOutput }
					</ul>
				</div>
			</div>
		);
	}

	handleChange( event ) {
		const country = event.target.value;

		this.props.informalUpdates.map( post => {
			if ( country === post.slug && post.id ) {
				this.setState( {
					               country,
					               countryName: post.name,
					               firms      : post.firms,
					               flag       : post.flag,
					               files      : post.files
				               } );
			}
		} );
	}

	render() {
		if ( !this.props.informalUpdates.length ) { return null; }
		let allJurisdictions = this.props.informalUpdates.map( ( el ) => {
			return (
				<option value={ el.slug }>{ el.name }</option>
			);
		} );
		return (
			<div className="entry-content">
				<div className="form-group form-group-format" id="dropdown-wrapper">
					<label htmlFor="informal-country-update-filter" id="dropdown-title"><strong>Select Jurisdiction</strong></label>
					<select id="informal-country-update-filter" className="form-control" onChange={ this.handleChange.bind( this ) }>
						<option value='' selected disabled>All Jurisdictions</option>
						{ allJurisdictions }
					</select>
				</div>
				<div>
					{ this.returnJurisdictionRow() }
				</div>
			</div>
		);
	}
}

function mapStateToProps( state ) {
	return {
		informalUpdates: state.informalUpdates
	};
}

export default connect( mapStateToProps, {
	fetchJurisdictionsDispatch
} )( InformalUpdateRow );